export default "__VITE_ASSET__h4sfPfYf__"